const PlatformRoutes = [
  {
    path: "/platform",
    name: "platform",
    component: () => import("@/components/layout/PlatformLayout.vue"),
    redirect: "/platform/overview",
    meta: {
      title: "평생학습플랫폼",
      isDynamic: false,
    },
    children: [
      /** 평생학습플랫폼 목록 */
      {
        label: "평생학습플랫폼 안내",
        path: "overview",
        component: () => import("@/views/student/platform/PlatformOverview.vue"),
      },
      {
        label: "비전 및 목표",
        path: "vision",
        component: () => import("@/views/student/platform/PlatformVision.vue"),
      },
      {
        label: "참여기관",
        path: "partners",
        component: () => import("@/views/student/platform/PlatformPartners.vue"),
      },
      {
        label: "ANCHOR 사업 개요",
        path: "rise",
        component: () => import("@/views/student/platform/PlatformRise.vue"),
      },
    ],
  },
];

export default PlatformRoutes;
